// Bundle/config products are brought as part of the order, so we are splitting those two types of
// orders depending on if the line has a property called parentNumber which indicates the
// lineNumber property inside the order

import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";

// TLDR; orders with property parentNumber are bundle/config products
export function xOrderLines(orderlines: Array<any>) {
    let orderlinesList = [];
    const partsList: any = {};
    // eslint-disable-next-line array-callback-return
    orderlinesList = orderlines.filter(orderLine => {
        const OrderLineParentLineNumber = `${Number(orderLine.properties.parentLineNumber)}`
        const ReleaseNumber = `${Number(orderLine.releaseNumber)}`

        if (!OrderLineParentLineNumber.length || !+OrderLineParentLineNumber) {
            return true;
        }
        if (OrderLineParentLineNumber) {
            if (!partsList[`${OrderLineParentLineNumber}-${ReleaseNumber}`]) {
                partsList[`${OrderLineParentLineNumber}-${ReleaseNumber}`] = [orderLine];
            } else {
                partsList[`${OrderLineParentLineNumber}-${ReleaseNumber}`].push(orderLine);
            }
        }
    });

    return { partsList, orderlinesList };
}

export function buildQuoteLinesPartList(quoteLines: QuoteLineModel[]) {
    let parentQuoteLines = [];
    const partsList: any = {};
    // eslint-disable-next-line array-callback-return
    parentQuoteLines = quoteLines.filter(quoteLine => {
        const parentQuoteLineNumber = `${Number(quoteLine.properties.parentLineNumber)}`

        if (!parentQuoteLineNumber.length || !+parentQuoteLineNumber) {
            return true;
        }
        const parentErpNumber = quoteLines[+parentQuoteLineNumber - 1].erpNumber;
        if (parentQuoteLineNumber) {
            if (!partsList[parentErpNumber]) {
                partsList[parentErpNumber] = [quoteLine];
            } else {
                partsList[parentErpNumber].push(quoteLine);
            }
        }
    });

    return { partsList, parentQuoteLines };
}